<template>
  <div class="max-w-screen-xl w-full mx-auto">
    <slot />
  </div>
</template>
